import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.organization.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-organization-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.organization.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageOrganizationItemComponent implements OnInit {
    public orgId: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.orgId = WizRoute.segment.id || '';
        await this.service.render();
    }
}

export default PageOrganizationItemComponent;